import React from 'react';
import PropTypes from 'prop-types';

export default class NavButton extends React.Component {
  render() {
    const {
      toStep,
      btnLabel,
      direction,
      clickHandler,
    } = this.props;

    return (
      <button
        type="button"
        className={`nav-btn nav-btn-${direction}`}
        data-to-step={toStep}
        onClick={clickHandler}
      >
        {btnLabel}
      </button>
    );
  }
}

NavButton.propTypes = {
  toStep: PropTypes.string.isRequired,
  btnLabel: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
};
